import { defineComponent as _defineComponent } from 'vue'
import BaseEditableCard from "@/components-UI/BaseEditableCard.vue";
import BaseListV2 from "@/components-UI/list/BaseListV2.vue";
import { ConversionCards } from "@/services/TablePage/conversionReport";
import { IConversion } from "@/api/types/conversions-report";
import { computed } from "vue";
import SvgClockPending from "@/assets/icons/clock-pending.svg";
import SvgAttention from "@/assets/icons/attention-symbol.svg";
import SvgCheck from "@/assets/icons/check.svg";
import SvgClock from "@/assets/icons/clock2.svg";
import { getRemainingTime, pluralRu } from "@/utils/formatDates";
import { translateHoldSource } from "@/utils/translate";

interface Props {
    cards: ConversionCards;
    conversion: IConversion;
    isLoading: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ConversionCards',
  props: {
    cards: null,
    conversion: null,
    isLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    cards: ConversionCards;
    conversion: IConversion;
    isLoading: boolean;
}



const leftCol = computed(() => Object.values(props.cards).filter((card) => card.col === 0));
const rightCol = computed(() => Object.values(props.cards).filter((card) => card.col === 1));

const getStatus = (status: string) => {
    switch (status) {
    case "rejected":
        return 'Отклонено';
    case "pending":
        return 'На рассмотрении';
    case "approved":
        return 'Принято';
    default:
        return '';
    }
};


return { __sfc: true,props, leftCol, rightCol, getStatus, BaseEditableCard, BaseListV2, SvgClockPending, SvgAttention, SvgCheck, SvgClock, getRemainingTime, pluralRu, translateHoldSource }
}

})